import React from 'react'
import { DateRangePickerContext } from './date-range-picker-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type DateRangePickerNextProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const DateRangePickerNext = React.forwardRef<HTMLDivElement, DateRangePickerNextProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(DateRangePickerContext)
    if (!context) {
      throw new Error('Cannot find date picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToNextMonth)
      })
    }
  }
) as WithForwardRefType
DateRangePickerNext.displayName = 'DateRangePickerNext'

interface WithForwardRefType extends React.FC<DateRangePickerNextProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(
    props: DateRangePickerNextProps<T>
  ): ReturnType<React.FC<DateRangePickerNextProps<T>>>
}
